<template>
<div class="header">
  <!-- START MOBILE CONTROLS -->
  <div class="container-fluid relative">
    <!-- LEFT SIDE -->
    <div class="pull-left full-height visible-sm visible-xs">
      <!-- START ACTION BAR -->
      <div class="header-inner">
        <a href="#" class="btn-link toggle-sidebar visible-sm-inline-block visible-xs-inline-block padding-5" data-toggle="sidebar">
          <span class="icon-set menu-hambuger"></span>
        </a>
      </div>
      <!-- END ACTION BAR -->
    </div>
    <div class="pull-center hidden-md hidden-lg">
      <div class="header-inner">
        <div class="brand inline">
        </div>
      </div>
    </div>
    <!-- RIGHT SIDE -->
    <div class="pull-right full-height visible-sm visible-xs">
      <!-- START ACTION BAR -->
      <div class="header-inner">
        <a href="#" class="btn-link visible-sm-inline-block visible-xs-inline-block" data-toggle="quickview" data-toggle-element="#quickview">
          <span class="icon-set menu-hambuger-plus"></span>
        </a>
      </div>
      <!-- END ACTION BAR -->
    </div>
  </div>
  <!-- END MOBILE CONTROLS -->
  <div class=" pull-left sidebar-width sm-table hidden-xs hidden-sm">
    <div class="header-inner">
      <div class="brand inline">        
        <h4 v-html="brand"></h4>
      </div>      
    </div>
  </div>

 
  <div class=" pull-right">
    <!-- START User Info-->
    <div class="visible-lg visible-md m-t-10">
      <div class="dropdown pull-left p-r-10 p-t-10 fs-16">
        <a href="#" class="small" data-toggle="dropdown" aria-haspopoup="true" aria-expanded="false">{{ $auth.current.data.name }}</a>
        <i class="fa fa-caret-down">&nbsp;</i>
        <ul class="dropdown-menu profile-dropdown" role="menu">
          <li><a href="#/profile"><i class="pg-settings_small"></i> Profile</a>
          </li>
          <li><a href="#/help"><i class="pg-signals"></i> Help</a>
          </li>
          <li class="bg-master-lighter">
            <a href="#" class="clearfix">
              <span @click="logout" class="pull-left">Logout</span>
              <span class="pull-right"><i class="pg-power"></i></span>
            </a>
          </li>
        </ul>
      </div>      
    </div>    
    <!-- END User Info-->
  </div>

  <div class="pull-left m-t-20" v-if="false">
    <ul class="notification-list no-margin hidden-sm hidden-xs b-grey no-style p-l-30 p-r-20">
      <li class="p-r-5 inline">
        <div ref="notifications" class="dropdown">
          <a  href="javascript:;" id="notification-center" class="icon-set globe-fill" data-toggle="dropdown">
            <span class="bubble"></span> 
          </a>                    
          <!-- START Notification Dropdown -->
          <div class="dropdown-menu notification-toggle" role="menu" aria-labelledby="notification-center">
            <!-- START Notification -->
            <div class="notification-panel">
              <!-- START Notification Body-->
              <div class="notification-body scrollable">
                <!-- START Notification Item-->
                <div class="notification-item unread clearfix">
                  <!-- START Notification Item-->
                  <div class="heading open">
                    <a href="#" class="text-complete pull-left">
                      <i class="pg-map fs-16 m-r-10"></i>
                      <span class="bold">Welcome</span>
                      <span class="fs-12 m-l-10">Proximi.io</span>
                    </a>
                    <div class="more-details">
                      <h5 class="semi-bold fs-16"></h5>
                    </div>
                  </div>
                  <!-- END Notification Item-->
                  <!-- START Notification Item Right Side-->
                  <div class="option" data-toggle="tooltip" data-placement="left" title="mark as read">
                    <a href="#" class="mark"></a>
                  </div>
                  <!-- END Notification Item Right Side-->
                </div>
              </div>
              <!-- END Notification Body-->
              <!-- START Notification Footer-->
              <div class="notification-footer text-center">
                <a href="#" class="">Read all notifications</a>
                <a data-toggle="refresh" class="portlet-refresh text-black pull-right" href="#">
                  <i class="pg-refresh_new"></i>
                </a>
              </div>
              <!-- START Notification Footer-->
            </div>
            <!-- END Notification -->
          </div>
          <!-- END Notification Dropdown -->
        </div>
      </li>
      <li class="p-r-15 inline" v-if="false">
        <div @click="showUnread" class="pointer">
          <span>You have <span class="text-black bold">1</span> unread notification</span>
        </div>
      </li>     
    </ul>
  </div>   
</div>
</template>

<script>

  export default {
    props: {
      brand: {
        type: String,
        default: ''
      },
      logout: {
        type: Function,
        default: () => {}
      }
    },
    created() {
      window.navbar = this
      this.$bus.$on('auth:logged_in', () => {
        console.log('navbar force')
        this.$forceUpdate();
      })
    },
    mounted() {
      this.$forceUpdate()
    },
    methods: {
      showUnread() {
        if (this.$refs.notifications.className.match(/open/)) {
          this.$refs.notifications.className = 'dropdown';
        } else {
          this.$refs.notifications.className = 'dropdown open';
        }
      }
    }
  }
</script>

<style>

  .header {
    border-bottom: 1px solid #eaeaea !important;
    background-image: url(~assets/img/grumpy.png);
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 130px 100px;
  }

  .brand.inline {
    padding-left: 50px;
  }

  body.menu-behind .header .brand {
    width: 300px;
  }
  .brand.brand.inline {
    width: 300px;
  }

  .profile-dropdown {
    margin-right: 100px;
  }

  .sidebar-width {
    width: 280px;
  }
</style>


// WEBPACK FOOTER //
// navbar.vue?35a68df8